'use strict';

module.exports = require('../../functions/makeLang')({
	ERROR: 'Invalid date!',
	MIN_DATE: 'You are way too old!',
	MAX_DATE: "I don't believe you're that young!"
});
